import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { AuthRepository, UserRole } from '../auth.repository';

@Injectable({
  providedIn: 'root'
})
export class AdminRoleGuard implements CanActivate, CanActivateChild {
  
  constructor(
    private authRepository: AuthRepository,
    private router: Router
  ) {}

  canActivate(): boolean {
    return this.hasAdminRole();
  }

  canActivateChild(): boolean {
    return this.hasAdminRole();
  }

  private hasAdminRole(): boolean {
    const user = this.authRepository.getUser();
    if (!user) {
      this.router.navigate(['/sign-in']);
      return false;
    }

    // NEW: Check is_admin flag first (RBAC superuser bypass)
    if (user.is_admin) {
      return true;
    }

    // NEW: Check permissions if available (RBAC system)
    if (user.permissions && user.permissions.length > 0) {
      const adminPermissions = ['mod_students', 'mod_courses', 'mod_settings', 'mod_supervisors'];
      const hasAdminPermission = user.permissions.some(p => adminPermissions.includes(p));
      if (hasAdminPermission) {
        return true;
      }
    }

    // FALLBACK: Legacy role check for backward compatibility
    const adminRoles = [
      UserRole.SuperUser,
      UserRole.SysAdmin, 
      UserRole.CourseAdmin,
      UserRole.Advisor,
      UserRole.Supervisor,
      UserRole.Translator
    ];

    const hasAdminRole = adminRoles.includes(user.role);
    
    if (!hasAdminRole) {
      // Redirect to home if user doesn't have admin role
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
} 